<template>
  <div class="t-month-grid">
    <cmp-calendar-body-header :type="1"></cmp-calendar-body-header>

    <div class="t-day t-day_notActive" :class="{'t-day_small': mobileCalendar}" v-for="(prev_day, index_prev_day) in days_before" :key="'prev_day_' + index_prev_day"></div>

    <cmp-day-create v-if="$route.name === 'courses_create' || $route.name === 'courses_edit'" v-for="(day, index_day) in day_in_month" :key="'day_' + index_day"
                        :lessons="lessons" :lesson_type="lesson_type" 
                        :day="day"></cmp-day-create>
    <cmp-day-my-courses v-if="$route.name === 'my_courses'" 
                        v-for="(day, index_day) in day_in_month" :key="'day_' + index_day"
                        :day="day"></cmp-day-my-courses>
    <cmp-day-my-entries v-if="$route.name === 'my_entries'" 
                        v-for="(day, index_day) in day_in_month" :key="'day_' + index_day"
                        :day="day"></cmp-day-my-entries>
    <cmp-day v-if="$route.name === 'courses_info'" 
                        v-for="(day, index_day) in day_in_month" :key="'day_' + index_day"
                        :day="day"></cmp-day>

    <div class="t-day t-day_notActive" :class="{'t-day_small': mobileCalendar}" v-for="(after_day, index_after_day) in days_after" :key="'after_day_' + index_after_day"></div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    import Day_create from './Create/Day.vue'
    import Day_my_courses from './MyCourses/Day.vue'
    import Day_my_entries from './MyEntries/Day.vue'
    import Day from './View/Day.vue'

    import CalendarBodyHeader from './CalendarBodyHeader.vue'
    
    export default {
        components: {
            'cmp-day-create': Day_create,
            'cmp-day-my-courses': Day_my_courses,
            'cmp-day-my-entries': Day_my_entries,
            'cmp-day': Day,
            'cmp-calendar-body-header': CalendarBodyHeader,
        },
        props: ['lessons', 'lesson_type'],
        computed: {
            ...mapGetters(['mobileCalendar']),
            ...mapGetters('calendar', ['days_before', 'day_in_month', 'days_after'])
        }
    }
</script>

<style lang="sass">
.t-month-grid
  display: flex
  width: 100%
  flex-wrap: wrap
</style>


// WEBPACK FOOTER //
// src/vue_components/Calendar/MonthGrid.vue